import request from "@/plugins/axios"
//附件
let prefix = "eids-invoice/attachment"

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

// 手工上传附件
export function addAttachment(data){
  return request({
    url: prefix + '/addAttachment',
    method: 'post',
    data: data,
  })
}

// 手工上传附件
export function removeAttachment(data){
  return request({
    url: prefix + '/removeAttachment',
    method: 'post',
    data: data,
  })
}

// 删除
export function deleterow(id) {
  return request({
    url: prefix + '/delete/' + id,
    method: 'get'
  })
}

// 查找滴滴的行程单
export function findDidiAttachment(data){
  return request({
    url: prefix + '/findDidiAttachment',
    method: 'post',
    data: data,
  })
}

// 查找顺丰的运单
export function findSfAttachment(data){
  return request({
    url: prefix + '/findSfAttachment',
    method: 'post',
    data: data,
  })
}


// 查找未匹配的附件
export function findNotMatchAttachment(orgId){
  return request({
    url: prefix + '/findNotMatchAttachment/' + orgId,
    method: 'get',
  })
}

// 执行关联
export function associate(fileProcessId, attachmentId){
  return request({
    url: prefix + '/associate/' + fileProcessId + "/" + attachmentId,
    method: 'get',
  })
}

